/* Old */
export const ORGANIZATION_TYPE_NON_PROFIT_ORGANIZATIONS = "NON_PROFIT_ORGANIZATIONS";
export const ORGANIZATION_TYPE_PRIVATE_COMPANY = "PRIVATE_COMPANY";
export const ORGANIZATION_TYPE_PUBLIC_SECTOR = "PUBLIC_SECTOR";

/* New */
export const ORGANIZATION_TYPE_SOCIAL_ECONOMY = "SOCIAL_ECONOMY_ORGANIZATIONS";
export const ORGANIZATION_TYPE_FOOD_PROCESSING = "FOOD_PROCESSING_ORGANIZATIONS";
export const ORGANIZATION_TYPE_AGRICULTURE = "AGRICULTURE_ORGANIZATIONS";
export const ORGANIZATION_TYPE_NON_PROFIT = "NON_PROFIT";
export const ORGANIZATION_TYPE_OTHER = "OTHER";
